/**
 * Dynamic socket generators — the step types whose sockets come from `config`
 * rather than from a fixed Zod schema.
 *
 * These live here, not in the backend, because each one has three consumers:
 * the backend save/read paths, the editor's live config-change path, and
 * template instantiation. `WorkflowEdge` stores socket ids as plain strings
 * with no FK, so two copies of a generator disagreeing about an id orphans
 * edges silently — the failure mode PR #5570 hit in production.
 */
export * from "./socketDefinition";
export * from "./statefulTableSocketTypes";
export * from "./codeSandboxSockets";
export * from "./collectResultsInputSockets";
export * from "./csvTransformV4InputSockets";
export * from "./entityResolverInputSockets";
export * from "./keyedInputSockets";
export * from "./matchCustomerWithEvidenceInputSockets";
export * from "./fanInOutputSockets";
export * from "./identifyCustomerOutputSockets";
export * from "./identifySupplierOutputSockets";
export * from "./identifyPartyOutputSockets";
export * from "./classifyEmailOutputSockets";
export * from "./splitDocumentV2OutputSockets";
export * from "./statefulTableSockets";
export * from "./switchOutputSockets";
export * from "./useDataMappingSockets";
export * from "./taskCreateInputSockets";
export * from "./dynamicSocketId";
export * from "./getProductVariantSockets";
export * from "./decomposeEntitySockets";
